export default {
  inputLabel: {
    id: 'footer_email_collector_input_label',
    defaultMessage: 'Email',
  },
  submitButtonLabel: {
    id: 'footer_email_collector_submit_button_label',
    defaultMessage: 'Sign up',
  },
  titleLabel: {
    id: 'footer_email_collector_title_label',
    defaultMessage: 'Get $15 off your first order.',
  },
  textLabel: {
    id: 'footer_email_collector_text_label',
    defaultMessage: 'On orders of $250 or more, when you sign up for emails.',
  },
  legalTermsLabel: {
    id: 'footer_email_collector_legal_terms_label',
    defaultMessage: 'Legal terms',
  },
  legalTextShort: {
    id: 'footer_email_collector_legal_text_short',
    defaultMessage:
      'By subscribing, you agree to receive our promotional communications via email. You can unsubscribe at any time using the link in any of our marketing emails, or request to access, rectify, or delete your data.',
  },
  legalTermsDetails: {
    id: 'footer_email_collector_legal_terms_details',
    defaultMessage: 'For more details, please refer to our privacy policy.',
  },
  legalTermsText: {
    id: 'footer_email_collector_legal_terms_text',
    defaultMessage:
      'A non-cumulative promotional code will be sent by email following newsletter registration. It is valid for a minimum order of $250 and is usable for 1 month from the date of receipt.',
  },
}
